import ApiLokalni   from "../ApiLokalni.ts";
import Profile from "./Model/Profile.ts";


export class ZapleczeApi extends ApiLokalni {
    private profile: Profile;

    constructor(token: string, profile: Profile) {
        super(token);
        this.profile = profile;
    }

    public getProfile() {
        return this.profile;
    }
}